import React, { useState } from 'react';
import { workspaceAPI } from '../../services/api';
import { MEMBER_PERMISSIONS, memberPermissions } from '../../utils/memberPermissions';

export default function MemberPermissions({ member, onSaved, onCancel }) {
  const [permissions, setPermissions] = useState(() => memberPermissions(member));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const save = async event => {
    event.preventDefault();
    if (saving) return;
    setSaving(true); setError('');
    try {
      const { data } = await workspaceAPI.updateMemberPermissions(member.userId, permissions);
      onSaved(data.permissions);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not save permissions. Your selections are still here.');
    } finally { setSaving(false); }
  };
  return <form onSubmit={save} aria-label={`Permissions for ${member.fullName || member.email}`} className="mt-4 border-t border-gray-200 pt-4">
    <fieldset disabled={saving} className="space-y-4">
      <legend className="font-semibold text-gray-900">Permissions</legend>
      <p className="text-xs text-gray-600">These switches control actions, not which enquiries or contacts are visible. Assignment rules still apply. Team administration, billing and enquiry deletion remain owner-only.</p>
      <div className="divide-y divide-gray-200">
        {MEMBER_PERMISSIONS.map(item => <label key={item.key} className="flex cursor-pointer items-start gap-3 py-3">
          <span className="min-w-0 flex-1"><span className="block text-sm font-medium text-gray-900">{item.label}</span><span id={`${member.userId}-${item.key}-help`} className="mt-1 block text-xs leading-5 text-gray-600">{item.description}</span></span>
          <input type="checkbox" role="switch" aria-label={item.label} aria-describedby={`${member.userId}-${item.key}-help`} checked={permissions[item.key]}
            onChange={event => setPermissions(current => ({ ...current, [item.key]: event.target.checked }))}
            className="mt-1 h-5 w-5 shrink-0 accent-primary-600" />
        </label>)}
      </div>
      <p className="text-xs text-gray-600">Changes apply when saved. Existing access is kept until then.</p>
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      <div className="flex flex-wrap gap-3">
        <button className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50">{saving ? 'Saving…' : 'Save permissions'}</button>
        <button type="button" onClick={onCancel} className="rounded-lg border border-gray-300 px-4 py-2 text-sm">Cancel</button>
      </div>
    </fieldset>
  </form>;
}
